import { useContext, useMemo } from 'react'
import { ObjectTypeEnum } from '../../types/SubCondition'
import { CustomFieldContext } from './CustomFieldProvider'
import { CustomFieldTypeFromService } from './CustomFieldTypes'

export function useCustomField(objectType: ObjectTypeEnum, fieldEId: string) {
    const context = useContext(CustomFieldContext)

    if (context === null) {
        throw 'Make sure this component has a CustomFieldProvider'
    }

    return useMemo(() => {
        switch(objectType) {
            case ObjectTypeEnum.Candidate:
                return context.getCandidateField(fieldEId)
            case ObjectTypeEnum.Requisition:
                return context.getJobField(fieldEId)
        }
    }, [
        objectType,
        fieldEId,
        context.getCandidateField,
        context.getJobField,
    ])
}

export function useCustomFieldOptions(objectType: ObjectTypeEnum): Array<CustomFieldTypeFromService> {
    const context = useContext(CustomFieldContext)

    if (context === null) {
        throw 'Make sure this component has a CustomFieldProvider'
    }

    return useMemo(() => {
        switch(objectType) {
            case ObjectTypeEnum.Candidate:
                return context.customFields.candidateFields
            case ObjectTypeEnum.Requisition:
                return context.customFields.jobFields
            default:
                return []
        }
    }, [
        objectType,
        context.customFields.candidateFields,
        context.customFields.jobFields,
    ])
}

export function useCustomFieldsLoading() {
    const context = useContext(CustomFieldContext)

    if (context === null) {
        throw 'Make sure this component has a CustomFieldProvider'
    }

    return useMemo(() => context.loading, [context.loading])
}